import "./static/assets/styles/global.module.scss"

import React from "react"

export const onRenderBody = ({ setHeadComponents }) => {
  setHeadComponents([
    <script
      key="gtag-src"
      async
      src="https://www.googletagmanager.com/gtag/js?id=AW-17804829262"
    />,
    <script
      key="gtag-inline"
      dangerouslySetInnerHTML={{
        __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-17804829262');
        `,
      }}
    />,
  ])
}
